export default {

// TOP SECTION

	title: `Charles Ollivon, objectif Webb Ellis !`,
	subTitle: `Au sommet`,

	intro:`Vainqueur avec son équipe du Rugby Club Toulonnais de la Challenge Cup 2023, Charles Ollivon est dans les <em>starting-blocks</em> pour la Coupe du Monde de Rugby 2023, qui se déroulera cet automne en France.`,

	authorName:`Victoire Chapellier`,
	authorTitle:`Victoire Chapellier est conceptrice-rédactrice. Passionnée de lecture, elle est également libraire à mi-temps.`,

// CAPTIONS
	imageCaption: `Charles Ollivon est ambassadeur de Société Générale depuis 2020.`,

// CONTENT

	content0: `Chez les Ollivon, à Saint-Pée-sur-Nivelle (64), le rugby est une affaire de famille. « Avant d’entrer chez les micro-poussins à l’âge de 5 ans, je passais déjà mes week-ends au stade à regarder mon frère jouer. Ensuite, tous les samedis, on allait ensemble à l’école de rugby, où mon père était entraîneur. Et le dimanche… on allait voir jouer la première division ! » <br/>
	Rencontre avec un joueur tombé dans le rugby quand il était petit.`,

	title1:`L’esprit d’équipe comme art de vivre`,

	content1_1:`Grandir dans une famille de passionnés au sein d’un village de 7 000 habitants est tout sauf anodin pour le jeune Charles Ollivon. Cette vie, qu’il qualifie de « simple et tranquille », entre rugby et pelote basque, entouré d’amis d’enfance, lui donne le goût de la solidarité et l’envie de défendre ses couleurs sans rien lâcher. « On est plus efficace sur le terrain quand on se bat pour son petit village de campagne et qu’on va au-delà de ses limites pour le copain d’à côté. La camaraderie, l’entraide et le plaisir sont des moteurs puissants pour gagner. » Ces valeurs, primordiales pour Charles Ollivon, il les retrouvera au niveau national, puis international.`,

	content1_2: `D’ailleurs, pour lui, l’esprit d’équipe est l’ADN de ce sport collectif, la condition sine qua non de la victoire. « Sans l’équipier qui se donne à fond dans la mêlée, je ne peux pas libérer le ballon pour marquer l’essai. Tous les gabarits sont utiles : il faut des forts, des maigres, des petits, des rapides pour remporter un match, et de l’intelligence aussi car plus le niveau monte, plus la guerre devient stratégique. C’est ensemble que tout se joue. Et puis, sur le terrain, l’affrontement physique peut être très dur, donc on fait front pour avancer. Les gens ressentent notre peur, notre engagement, la confiance qui nous unit les uns aux autres. C’est pour cette raison que le rugby fait tellement vibrer. »`,


	title2:`Un engagement total`,

	content2_1:`De grandes émotions, Charles Ollivon nous en promet en septembre prochain. « On va donner tout ce qu’on a sur le terrain. La pression monte en France autour de notre sport et de cette coupe que nous n’avons jamais gagnée. Mais cette attente n’est pas un poids, elle nous donne la force de travailler encore plus au quotidien et l’énergie pour nous surpasser à l’instant T. On a beaucoup travaillé pour que la France fasse partie des favoris. Maintenant, nous sommes tous au niveau, donc il va falloir aller chercher la coupe ! J’aime les challenges, je ne viens pas pour participer mais pour gagner ! J’imagine bien une finale contre l’Afrique du Sud pour leur prendre le trophée… »`,

	content2_2: `Charles Ollivon n’est pas qu’un joueur, c’est aussi un être humain qui a su tirer des leçons de vie. « Les différentes épreuves que j’ai dû surmonter en 2019 ont modifié ma vision du rugby et de la vie. Malgré les blessures et les rechutes – j’ai failli ne plus pouvoir jouer à l’international –, je me suis battu et j’ai fini par partir au Japon, où j’ai vécu des moments inoubliables, à la hauteur des difficultés rencontrées. J’ai réalisé la chance que j’avais de faire ce métier. Aujourd’hui, je suis moins dans la projection et davantage dans le moment présent. Je vais savourer chaque instant de cette Coupe du monde, profiter de tout à 200 % comme me l’a conseillé mon ami <span class='renvoi' data-tippy-content='Ancien joueur international de rugby argentin et du Rugby Club Toulonnais.'>Juan Martin Fernandez Lobbe</span>. »`,

// ENCADRE

	encadreTitle: `Charles Ollivon en 6 dates`,

	encadreDate_1: `1993`,
	encadreTexte_1: `Naissance à Saint-Pée-sur-Nivelle, commune du Pays basque frontalière de l’Espagne.`,

	encadreDate_2: `2009`,
	encadreTexte_2: `Après avoir été formé au Saint-Pée UC puis à l’Entente de la Nivelle, il entre à l’Aviron bayonnais. C’est au sein de ce club qu’il fait ses débuts en Top 14 en 2013.`,

	encadreDate_3: `2015`,
	encadreTexte_3: `Après la relégation du club basque en Pro D2, Ollivon rejoint le Rugby Club Toulonnais.`,

	encadreDate_4: `2016`,
	encadreTexte_4: `Appelé pour le stage de préparation de la tournée d’automne de l’équipe de France, il marque son 1<sup>er</sup> essai international contre l’équipe des Samoa.`,

	encadreDate_5: `2019`,
	encadreTexte_5: `Retour en Bleu après avoir été blessé à l’épaule en 2017. Il marque le 2<sup>e</sup> essai français durant le quart de finale de la Coupe du monde de 2019 contre le pays de Galles.`,

	encadreDate_6: `2020`,
	encadreTexte_6: `Il est capitaine du XV de France pour la première fois lors du Tournoi des Six Nations 2020. Avec quatre essais, il est le meilleur marqueur de cette édition.`,

// CARTE BLANCHE

	titleCarteBlanche: `Carte blanche à Claire Prouvost`,

	introCarteBlanche: `Pour chaque édition, un ou une artiste illustre l’un des thèmes traités dans le magazine. Claire Prouvost, illustratrice française installée à Dublin, a choisi le rugby. Son univers haut en couleur est doté de formes joyeuses inspirées par le mouvement cubiste.`,

// VIDEO
	
	videoIntro: `Découvrez la <a href="https://www.youtube.com/playlist?list=PLO28QHeP4SE7lu533jwO79YpWZiyZ0wmD" target="_blank">saison 4</a> de la série documentaire Terrain favorable <br/>
	réalisée à l’occasion de la prochaine Coupe du Monde de Rugby`,

	videoCaption: `Épisode 1`,

// QUOTE

	quote001: `“ Il faut les qualités de chacun pour remporter un match. ”`,

	
};

